import React, { useEffect, useState } from "react"
import { InfoType } from "../types/hashtagSearchPostDatas"
import "./styles/styles.css"

const TeamfluencerInstaData = (data: any) => {
  const [insta, setInsta] = useState({
    id: "",
    username: "",
    full_name: "",
    biography: "",
    edge_followed_by: {
      count: 0,
    },
    edge_follow: {
      count: 0,
    },
    highlight_reel_count: 0,
    edge_owner_to_timeline_media: {
      count: 0,
    },
  })

  useEffect(() => {
    setInsta(data.data)
  }, [data])

  const postInfo: InfoType[] = [
    { key: "Hesap ID:", value: String(insta?.id) },
    { key: "Kullanıcı Adı:", value: String(insta?.username) },
    { key: "IG Tam isim:", value: String(insta?.full_name) },
    { key: "Biyografi:", value: String(insta?.biography) },
    { key: "Medya Sayısı:", value: String(insta?.edge_owner_to_timeline_media.count) },
    { key: "Takipçi Sayısı:", value: Number(insta?.edge_followed_by?.count) },
    { key: "Takip Sayısı:", value: Number(insta?.edge_follow?.count) },
    { key: "Öne Çıkan Reels Sayısı:", value: String(insta?.highlight_reel_count) },
  ]

  return (
    <div className="post-info">
      {postInfo.map((info) => (
        <div key={info.key} className="flex post-info-item">
          <div className="post-info-item-key font-bold">{info.key}</div>
          <div className="pl-4 post-info-item-value">
            {Array.isArray(info.value) ? JSON.stringify(info.value) : String(info.value)}
          </div>
        </div>
      ))}
    </div>
  )
}

export default TeamfluencerInstaData
